import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import useId from '@indeed/ihl-use-id';
import { FORM_SIZES } from '../../constants/index.js';
import { parseItems } from '../../utils/fields.js';
import { FormField } from '../FormField/FormField.js';
import { Chip } from '../Chip/Chip.js';
import { ChipGroup } from '../Chip/ChipGroup.js';
import { jsx } from '@emotion/react';
import '@indeed/ifl-css';
import '@indeed/ifl-icons';
import '../../utils/createResponsive.js';
import '../Label/Label.js';
import '../../utils/styled.js';
import '../../utils/transition.js';
import '../VisuallyHidden/VisuallyHidden.js';
import '../Text/Text.js';
import '../Box/Box.js';
import '../Flex/Flex.js';
import '@emotion/is-prop-valid';
import '../../hooks/useResponsiveValue.js';
import '../../hooks/useBreakpointIndex.js';
import '../Button/Button.js';
import '../../utils/transparentize.js';
import '../Button/context.js';
import '../IndeedThemeProvider/hooks/useColorMode.js';
import '../IndeedThemeProvider/hooks/useColorModeAttribute.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../Spinner/Spinner.js';
import '../IconWrapper/IconWrapper.js';
import '../../utils/displayName.js';

const ChipFormField = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    items,
    id,
    label,
    sx,
    name,
    type = "single",
    ...props
  } = _ref;
  const defaultId = `ifl-ChipFormField-${useId()}`;
  const fieldId = id || defaultId;
  const parsedItems = parseItems(items);
  return jsx(FormField, _extends({
    as: "fieldset",
    ref: ref,
    label: label,
    sx: sx,
    id: fieldId
  }, props), jsx(ChipGroup, _extends({
    type: type,
    name: name
  }, props), parsedItems.map((chipProps, index) => jsx(Chip, _extends({
    key: `${fieldId}-${index}`
  }, chipProps)))));
});
const CHIP_FORM_FIELD_SIZES = FORM_SIZES;
const CHIP_FORM_FIELD_TYPES = ["single", "multiple", "removable"];
ChipFormField.displayName = "ChipFormField";

export { CHIP_FORM_FIELD_SIZES, CHIP_FORM_FIELD_TYPES, ChipFormField };
